import BrandedVisual from "./BrandedVisual";

// Auto-map internal label descriptions to authentic image files stored under
// /api/media (imported from the current dentiservice.ro production site).
// When an authentic file exists for the label context, render the photo; else
// fall back to a themed BrandedVisual illustration.
const AUTHENTIC = [
  // pattern (case-insensitive substring or /regex/) -> media path
  [/cerec|primescan|primemill/i, "/api/media/service-cerec.jpg"],
  [/implant.*digital|planificare implant|megagen/i, "/api/media/service-implant-digital-400.webp"],
  [/all-on|all on 4|dinți ficși/i, "/api/media/service-implant-digital-400.webp"],
  [/microscop|endodon/i, null],  // No public image for endodontie — use branded illustration instead of ChatGPT-generated file
  [/laser.*biolase|waterlase|albire/i, "/api/media/service-albire-biolase.jpg"],
  [/modjaw/i, "/api/media/service-modjaw.jpg"],
  [/diagnostic.*digital|cbct|axeos|scanare intraoral/i, "/api/media/service-diagnostic-digital.jpeg"],
];

function resolveAuthentic(label) {
  if (!label) return null;
  for (const [re, path] of AUTHENTIC) if (re.test(label)) return path;
  return null;
}

export default function ImagePlaceholder({ label, aspect = "aspect-[4/3]", className = "", src, alt, variant }) {
  // Explicit src wins.
  let finalSrc = src;
  if (!finalSrc && !variant) {
    for (const [re, path] of AUTHENTIC) {
      if (re.test(label || "")) {
        if (path) finalSrc = `${process.env.REACT_APP_BACKEND_URL}${path}`;
        break;
      }
    }
  }
  if (finalSrc) {
    return (
      <div className={`rounded-2xl overflow-hidden w-full ${aspect} ${className} bg-slate-100 shadow-sm`} data-testid="brand-image">
        <img src={finalSrc} alt={alt || label || ""} className="w-full h-full object-cover" loading="lazy" />
      </div>
    );
  }
  // No authentic photo → use a themed illustration variant.
  const guess = (label || "").toLowerCase();
  const auto =
    /cbct|radiogr/i.test(guess) ? "scanner"
    : /cerec|primescan|primemill/i.test(guess) ? "crown"
    : /implant|all-on|all on|planificare implant/i.test(guess) ? "implant"
    : /microscop|endodon/i.test(guess) ? "microscope"
    : /laser|biolase|waterlase/i.test(guess) ? "laser"
    : /ems|airflow|igieniz/i.test(guess) ? "ems"
    : /modjaw/i.test(guess) ? "modjaw"
    : /ortodon|aliniere/i.test(guess) ? "orthodontics"
    : /urgen/i.test(guess) ? "urgent"
    : /diaspor|strain/i.test(guess) ? "diaspora"
    : /hart|locație|contact|ruta/i.test(guess) ? "map"
    : /bruxism/i.test(guess) ? "bruxism"
    : /diagnostic|digital/i.test(guess) ? "digital"
    : /protetic|coroan|lucr/i.test(guess) ? "prosthetics"
    : /parodon|gingi/i.test(guess) ? "gum"
    : /albire|estetic/i.test(guess) ? "aesthetic"
    : /echip|medicală|medic|dr\./i.test(guess) ? "team"
    : "clinic";
  return <BrandedVisual variant={variant || auto} aspect={aspect} className={className} />;
}
